module.exports = __webpack_public_path__ + "img/fuwuwaibao.62b89291.png";